import Swiper from 'swiper';
import {Navigation, Pagination, Autoplay, EffectFade, A11y, Keyboard} from 'swiper/modules';

window.Swiper = Swiper;

(() => {
    const swiperItems = document.querySelectorAll('.swiper[data-swiper]');
    if (swiperItems?.length === 0) return;
    swiperItems.forEach(swiperItem => {
        const dataSwiperAttributes = swiperItem.dataset.swiper;
        const dataSwiper = dataSwiperAttributes ? JSON.parse(dataSwiperAttributes) : null
        const dataSwiperOptions = {
            modules: [A11y, Keyboard],
            init: dataSwiper?.init ?? true,
            allowTouchMove: dataSwiper?.allowTouchMove ?? true,
            autoHeight: dataSwiper?.autoHeight ?? false,
            autoplay: dataSwiper?.autoplay ?? {delay: 4000},
            breakpoints: dataSwiper?.breakpoints ?? null,
            centeredSlides: dataSwiper?.centeredSlides ?? false,
            effect: dataSwiper?.effect ?? 'slide',
            loop: dataSwiper?.loop ?? false,
            pagination: dataSwiper?.pagination ?? {el: ".swiper-pagination", clickable: true},
            navigation: dataSwiper?.navigation ?? {nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'},
            slidesPerGroup: dataSwiper?.slidesPerGroup ?? 1,
            slidesPerView: dataSwiper?.slidesPerView ?? 1,
            spaceBetween: dataSwiper?.spaceBetween ?? 0,
            speed: dataSwiper?.speed ?? 1200,
            direction: dataSwiper?.direction ?? 'horizontal',
            a11y: {
                enabled: true,
                prevSlideMessage: 'Slide precedente',
                nextSlideMessage: 'Slide successiva',
                firstSlideMessage: 'Questa è la prima slide',
                lastSlideMessage: 'Questa è l\'ultima slide',
                paginationBulletMessage: 'Vai alla slide {{index}}',
                notificationClass: 'swiper-notification',
                containerMessage: 'Carosello scorrevole con vari elementi',
                slideLabelMessage: 'Slide {{index}} di {{slidesLength}}',
                containerRoleDescriptionMessage: 'carousel',
                itemRoleDescriptionMessage: 'slide',
                containerRole: 'group'
            },
            keyboard: {
                enabled: true,
                onlyInViewport: true,
                pageUpDown: true
            }
        };

        if (swiperItem.hasAttribute('data-swiper-autoplay')) dataSwiperOptions.modules.push(Autoplay);
        if (swiperItem.hasAttribute('data-swiper-navigation')) dataSwiperOptions.modules.push(Navigation);
        if (swiperItem.hasAttribute('data-swiper-pagination')) dataSwiperOptions.modules.push(Pagination);
        if (dataSwiper?.hasOwnProperty('effect') && dataSwiper.effect === 'fade') {
            dataSwiperOptions.modules.push(EffectFade);
            dataSwiperOptions.fadeEffect = {crossFade: true}
        }

        // Swiper init
        const swiperItemObject = new Swiper(swiperItem, dataSwiperOptions);
        swiperItem.swiperInstance = swiperItemObject;
    });
})()
